import React from "react";
import PropTypes from "prop-types";
import { selectedText } from "./actionPanelStyles.module.scss";

export default function SelectDisplay({ selected, children }) {
  return (
    <>
      <div className="col-2">
        <div data-title="selectedCount" className={selectedText}>
          {selected.length} Selected
        </div>
      </div>

      <div className="col d-inline-flex">
        {children}
      </div>
    </>
  );
}

SelectDisplay.propTypes = {
  selected: PropTypes.array.isRequired,
  children: PropTypes.node
};

SelectDisplay.defaultProps = {
  children: null
};
